import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { logout as logoutAction } from "../reducer/Actions";
import { Link, useNavigate } from "react-router-dom";
import menuss from "../image/icons/align-left.svg";
import x from "../image/icons/x.svg";
import { FaAngleLeft, FaDollarSign } from "react-icons/fa";
import { BiHomeAlt, BiSupport } from "react-icons/bi";
import { LiaPhoneSolid } from "react-icons/lia";
import { LuBadgeInfo } from "react-icons/lu";
import { TbLayoutDashboard } from "react-icons/tb";
import { CgProfile } from "react-icons/cg";
import { MdOutlinePayment, MdPrivacyTip } from "react-icons/md";
import { FiLogOut } from "react-icons/fi";
import { FaRegCircleCheck } from "react-icons/fa6";

import Employee from "../image/Employee.png";
import Hirebeengreen from "../image/Hirebeengreen.svg";
import hirebeen from "../image/hirebeenLogo.png";
import H from "../image/H.png";
import { API_URL } from "../apiConfig";
import CSRFToken from "../cookies.js";
import Coin from "../image/ethereum.png";
import TYPE from "../reducer/Type.js";
import {toast} from 'react-toastify';


const CREDITS_TYPE = [
  {
    Type: "Experience",
    Credits: 2,
  },
  {
    Type: "Profile Summary",
    Credits: 2,
  },
  {
    Type: "Project Summary",
    Credits: 1,
  },
  {
    Type: "Create Resume",
    Credits: 5,
  },
];

const Navbar = ({ logout, isAuthenticated, hideLinks }) => {
  const [profileData, setProfileData] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menusOpen, setMenusOpen] = useState(false);
  const [showCredits, setShowCredits] = useState(false);
  const navigate = useNavigate();
  const user = useSelector((state) => state.AuthReducer?.user);
  const dispatch = useDispatch();
  const menusRef = useRef(null);
  const menuRef = useRef(null);

  const handleMenusClickOutside = (event) => {
    if (menusRef.current && !menusRef.current.contains(event.target)) {
      setMenusOpen(false);
    } else if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    if (menusOpen) {
      document.addEventListener("mousedown", handleMenusClickOutside);
    } else {
      document.removeEventListener("mousedown", handleMenusClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleMenusClickOutside);
    };
  }, [menusOpen]);

  useEffect(() => {
    if (menuOpen) {
      document.addEventListener("mousedown", handleMenusClickOutside);
    } else {
      document.removeEventListener("mousedown", handleMenusClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleMenusClickOutside);
    };
  }, [menuOpen]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleMenus = () => {
    setMenusOpen(!menusOpen);
  };

  const handleLogout = async () => {
    const success = await logout();
    if (success) {
      navigate("/");
    }else {
      toast.error("Something went wrong. Please try again later",{
        autoClose:1500
      })
    }
  };

  const fetchUserProfile = async () => {
    try {
      const authToken = localStorage.getItem("access");

      const response = await fetch(`${API_URL}/fetch-user-profile`, {
        method: "GET",
        headers: {
          "X-CSRFToken": CSRFToken(document.cookie),
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = await response.json();

      dispatch({
        type: TYPE.GET_USER_SUCCESS,
        payload: {
          user: data,
        },
      });
      return;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);
  //style={{position: sticky, top: 0px, z-index: 1}}
  return (
    <div className="sticky top-0 bg-white container-fluid z-[9999999]">
      <div className="sticky top-0 flex justify-between w-full px-8 bg-white border-b-2 border-white mt-1.5 mb-1.5 text-ellipsist-base z-100 gap-14 text-slate-700">
        <Link to="/" className="self-stretch my-auto">
          <img
            loading="lazy"
            src={Hirebeengreen}
            className="w-40 max-w-full pl-5 my-auto ml-2 shrink-0"
            alt="Logo"
          />
        </Link>

        {!hideLinks ? (
          <div className="items-center justify-end hidden gap-5 md:flex max-md:flex-wrap max-md:max-w-full ">
            <Link to="/" className="self-stretch my-auto text-xl font-medium ">
              Home
            </Link>
            <Link
              to="/pricing"
              className="self-stretch my-auto text-xl font-medium"
            >
              Pricing
            </Link>
            <Link
              to="/contact-us"
              className="self-stretch my-auto text-xl font-medium"
            >
              Contact
            </Link>
            <Link
              to="/about-us"
              className="self-stretch my-auto text-xl font-medium"
            >
              About
            </Link>
          </div>
        ) : (
          <Link
            to="/dashboard"
            className="flex-row items-center hidden w-full cursor-pointer md:flex"
          >
            <FaAngleLeft className="h-full p-1" />
            <span>Dashboard</span>
          </Link>
        )}

        {/* Large */}
        <div className="hidden md:block md:p-6">
          {isAuthenticated ? (
            <div className="flex gap-3 w-36">
              {/* Credits */}
              <div
                className="flex items-center content-center justify-center w-full gap-1 px-2 rounded-full bg-slate-200 hover:cursor-pointer"
                onClick={() => setShowCredits(!showCredits)}
              >
                <img src={Coin} alt="" className="w-6 h-6" />
                <p className="text-lg font-semibold">
                  {user?.user?.available_tokens ?? 0}
                </p>
              </div>
              <div className="relative">
                <img
                  src={profileData?.profile_pic || Employee}
                  alt="Profile"
                  className="flex w-16 h-12 rounded-full cursor-pointer float-end border-1 "
                  onClick={toggleMenus}
                />
                {menusOpen && (
                  <div
                    className="absolute right-0 z-10 w-48 mt-10 bg-white border rounded-md shadow-lg"
                    ref={menusRef}
                  >
                    <Link
                      to="/dashboard"
                      className="block px-4 py-2 text-gray-800 cursor-pointer hover:bg-gray-200"
                    >
                      Dashboard
                    </Link>
                    <Link
                      to="/profile"
                      className="block px-4 py-2 text-gray-800 cursor-pointer hover:bg-gray-200"
                    >
                      Profile
                    </Link>
                    <Link
                      to="/payments"
                      className="block px-4 py-2 text-gray-800 cursor-pointer hover:bg-gray-200"
                    >
                      Payments
                    </Link>
                    <span
                      onClick={handleLogout}
                      className="block px-4 py-2 text-gray-800 cursor-pointer hover:bg-gray-200"
                    >
                      Logout
                    </span>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <Link
              to="/Login"
              className="self-stretch justify-center px-3 py-2 font-medium text-white rounded-3xl bg-zinc-800 max-md:px-5"
            >
              Create My Resume
            </Link>
          )}
        </div>

        {/* Mobile-tab device */}
        <div className="md:hidden">
          <div className="flex gap-3 m-2">
            <div className="flex flex-row items-center content-center justify-center w-full gap-2 px-2 rounded-full bg-slate-200">
              <img src={Coin} alt="" className="w-6 h-6" />
              <p className="text-lg font-semibold">
                {user?.user?.available_tokens ?? 0}
              </p>
            </div>
            {!menuOpen ? (
              <img
                src={menuss}
                alt="Menu"
                className="w-auto h-auto rounded-full cursor-pointer"
                onClick={toggleMenu}
              />
            ) : (
              <img
                src={x}
                alt="Close"
                className="w-auto h-auto rounded-full cursor-pointer"
                onClick={toggleMenu}
              />
            )}

            {menuOpen && (
              <div
                className={`flex flex-col justify-between absolute mr-10 top-0 left-0 mt-5 w-3/4 h-screen bg-[#1E6463] font-semibold border rounded-md shadow-lg z-50 transition duration-700 ease-in-out`}
                ref={menuRef}
                style={{ left: "-4%" }}
              >
                <div className="py-2">
                  {!hideLinks && (
                    <>
                      <Link to="/" className="block pl-9">
                        <div className="flex mt-4 mb-4">
                          <img
                            loading="lazy"
                            src={H}
                            className="w-10 max-w-full pl-5 my-auto ml-2 shrink-0"
                            alt="Logo"
                          />
                          <img
                            loading="lazy"
                            src={hirebeen}
                            className="max-w-full pl-2 my-auto w-28 shrink-0"
                            alt="Logo"
                          />
                        </div>
                      </Link>
                      <Link
                        to="/"
                        className="block py-2 text-white pl-9 hover:bg-orange-500"
                      >
                        <div className="flex items-center gap-x-2">
                          <BiHomeAlt className="w-6 h-6 " />
                          <p className="font-sans text-xl font-normal hover:ease-linear">
                            Home
                          </p>
                        </div>
                      </Link>

                      {isAuthenticated && (
                        <>
                          <Link
                            to="/dashboard"
                            className="block py-2 text-white pl-9 hover:bg-orange-500"
                          >
                            <div className="flex items-center gap-x-2">
                              <TbLayoutDashboard className="w-6 h-6" />
                              <p className="text-xl font-normal">Dashboard</p>
                            </div>
                          </Link>
                          <Link
                            to="/payments"
                            className="block py-2 text-white pl-9 hover:bg-orange-500"
                          >
                            <div className="flex items-center gap-x-2">
                              <MdOutlinePayment className="w-6 h-6" />
                              <p className="text-xl font-normal">Payments</p>
                            </div>
                          </Link>
                          <Link
                            to="/profile"
                            className="block py-2 text-white pl-9 hover:bg-orange-500"
                          >
                            <div className="flex items-center gap-x-2">
                              <CgProfile className="w-6 h-6" />
                              <p className="text-xl font-normal">Profile</p>
                            </div>
                          </Link>
                        </>
                      )}

                      <Link
                        to="/pricing"
                        className="block py-2 text-white pl-9 hover:bg-orange-500"
                      >
                        <div className="flex items-center gap-x-2">
                          <FaDollarSign className="w-6 h-6" />
                          <p className="text-xl font-normal">Pricing</p>
                        </div>
                        {/* Pricing */}
                      </Link>
                      <Link
                        to="/contact-us"
                        className="block py-2 text-white pl-9 hover:bg-orange-500"
                      >
                        <div className="flex items-center gap-x-2">
                          <LiaPhoneSolid className="w-6 h-6" />
                          <p className="text-xl font-normal">Contact</p>
                        </div>
                        {/* Contact */}
                      </Link>
                      <Link
                        to={"/about-us"}
                        className="block py-2 text-white pl-9 hover:bg-orange-500"
                      >
                        <div className="flex items-center gap-x-2">
                          <LuBadgeInfo className="w-6 h-6" />
                          <p className="text-xl font-normal">About us</p>
                        </div>
                      </Link>
                    </>
                  )}
                  
                  <Link
                    to="/privacy-page"
                    className="flex py-2 text-white gap-x-2 pl-9 hover:bg-orange-500"
                  >
                    <MdPrivacyTip className="w-6 h-6" />
                    <p className="text-xl font-normal">Privacy Policy</p>
                  </Link>
                  
                </div>

                <div className="mb-28">
                  <Link
                    to={"/termsAndConditions"}
                    className="flex py-2 text-white gap-x-2 pl-9 hover:bg-orange-500"
                  >
                    <FaRegCircleCheck className="w-6 h-6" />
                    <p className="text-xl font-normal">Terms & Conditions</p>
                  </Link>
                  {isAuthenticated && (
                    <span
                      onClick={handleLogout}
                      className="block py-2 text-white cursor-pointer pl-9 hover:bg-orange-500"
                    >
                      <div className="flex items-center gap-x-2">
                        <FiLogOut className="w-7 h-7" />
                        <p className="text-2xl font-normal">Logout</p>
                      </div>
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.AuthReducer.isAuthenticated,
  };
};

export default connect(mapStateToProps, { logout: logoutAction })(Navbar);
